import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAccounts } from '../api/getAccounts';
import { mapAccount, AccountView } from '../lib/mapAccount';
import { accountsKeys } from './useAccounts';

/**
 * The signed-in client's accessible accounts, mapped to AccountView. Shares the
 * `accountsKeys.list` cache with useAccounts (same fetcher/key) so opening the
 * picker and then a project reuses one /api/accounts response. The endpoint is
 * already scope-filtered server-side, so for a client this is exactly their
 * companies.
 */
export const useClientCompanies = () => {
  const query = useQuery({
    queryKey: accountsKeys.list,
    queryFn: getAccounts,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  const companies: AccountView[] = useMemo(
    () => (query.data?.accounts ?? []).map(mapAccount),
    [query.data]
  );

  return {
    companies,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
